import {create} from 'zustand';

interface SessionState {
    isAuthorized: boolean;
    isLoggedInAsOtherUser: boolean;
    isPublicUser: boolean;
    isToken: boolean;
    key: string | null;
    publicMethods: string[];
}

// a store to hold applicable session info for react and can be kept in sync by the backbone session _singleton_
export const useSessionStore = create<SessionState>()((set, get) => ({
    isAuthorized: false,
    isLoggedInAsOtherUser: false,
    isPublicUser: false,
    isToken: false,
    key: null,
    publicMethods: [],
}));
